import React, { useState } from "react"

import { useAppDispatch } from "redux/hooks"
import { makeSignPaymentSchedule } from "redux/features/payment_schedule/paymentScheduleSignThunk"
import Spinner from "components/ui/Spinner"
import SmartId from "components/Sign/SmartId"
import { ClientSmartIdFormValues } from "types"
import { SMART_ID_SIGN_METHOD } from "config"

type Props = {
  paymentScheduleId: string
  onFailure: () => void
  onSuccess: () => void
}

const SmartIdSignComponent = ({
  paymentScheduleId,
  onFailure,
  onSuccess,
}: Props) => {
  const dispatch = useAppDispatch()

  const [isSubmitting, setSubmitting] = useState(false)

  const handleSubmit = (values: ClientSmartIdFormValues) => {
    setSubmitting(true)

    const { country, personal_code } = values

    const params = {
      payment_schedule_id: paymentScheduleId,
      signing_method: SMART_ID_SIGN_METHOD,
      country,
      personal_code,
    }

    dispatch(makeSignPaymentSchedule(params))
      .then(() => {
        onSuccess()
      })
      .catch(() => {
        onFailure()
      })
      .finally(() => {
        setSubmitting(false)
      })
  }

  return (
    <>
      <Spinner open={isSubmitting} />
      <SmartId onSubmit={handleSubmit} />
    </>
  )
}

export default SmartIdSignComponent
